import { enumFacilitySortOption } from '@rematter/frontend-lib-api-client';

import { createEntitySelect } from './helpers/createEntitySelect';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const facilitiesQueryAtom = createQueryAtomFactory(
  'shared.selectFacility',
  () => ({
    facilities: {
      __args: {
        sorting: [enumFacilitySortOption.NameAsc],
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        facilityName: true,
      },
    },
  }),
  {
    select: (data) => data?.facilities.entries ?? [],
  },
);

export const SelectFacility = createEntitySelect(
  'SelectFacility',
  facilitiesQueryAtom,
  {
    formatLabel: (entity) => entity.facilityName,
  },
);
